import BaseApi from './baseAPI'

class CommentAPI extends BaseApi{

  get entity() {
    return {
      route: `${this.getCourseId()}/comments`,
      name: 'التعليق'
    }
  }
}

export default new CommentAPI()
